import { cn } from '@utils/cn';
import { ElementType, PropsWithChildren, ReactNode } from 'react';

export const Tile = ({
  children,
  className,
  dataTestid,
  direction = 'row',
}: PropsWithChildren<{
  className?: string;
  dataTestid?: string;
  direction: 'column' | 'row';
}>) => {
  return (
    <div
      className={cn(
        'relative flex w-full flex-row gap-3',
        {
          'flex-col': direction === 'column',
        },
        className,
      )}
      data-testid={dataTestid}
    >
      {children}
    </div>
  );
};

export const TileMedia = ({
  children,
  className,
  overlay,
}: PropsWithChildren<{ className?: string; overlay?: ReactNode }>) => {
  return (
    <div
      className={cn(
        'relative flex flex-col gap-3 overflow-hidden rounded-sm',
        className,
      )}
    >
      {children}
      {overlay ? (
        <div className="absolute inset-x-0 top-0 z-10 flex items-center justify-end gap-2 p-3">
          {overlay}
        </div>
      ) : null}
    </div>
  );
};

export const TileContent = ({
  children,
  className,
  direction = 'row',
}: PropsWithChildren<{
  className?: string;
  direction: 'column' | 'row';
}>) => {
  return (
    <div
      className={cn(
        'flex flex-row items-center justify-center',
        {
          'flex-col': direction === 'column',
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export const TileTitle = ({
  as: As = 'span',
  children,
  className,
}: PropsWithChildren<{ as?: ElementType; className?: string }>) => {
  return (
    <As
      className={cn(
        'w-full text-left font-bold text-neutral-6 theme-dark:text-white',
        className,
      )}
    >
      {children}
    </As>
  );
};

export const TileText = ({
  as: As = 'span',
  children,
  className,
  variant = 'default',
}: PropsWithChildren<{
  as?: ElementType;
  className?: string;
  variant?: 'default' | 'muted' | 'active';
}>) => {
  return (
    <As
      className={cn(
        'w-full text-left',
        {
          'text-neutral-6 theme-dark:text-white': variant === 'default',
          'text-neutral-4 theme-dark:text-neutral-3': variant === 'muted',
          'text-active-4 theme-dark:text-active-3': variant === 'active',
        },
        className,
      )}
    >
      {children}
    </As>
  );
};
